import LegalPageLayout from '../components/LegalPageLayout';

const sections = [
  { id: 'article-1', title: 'Article 1 - Responsable du Traitement' },
  { id: 'article-2', title: 'Article 2 - Données Collectées' },
  { id: 'article-3', title: 'Article 3 - Finalités du Traitement' },
  { id: 'article-4', title: 'Article 4 - Base Légale' },
  { id: 'article-5', title: 'Article 5 - Destinataires des Données' },
  { id: 'article-6', title: 'Article 6 - Durée de Conservation' },
  { id: 'article-7', title: 'Article 7 - Vos Droits' },
  { id: 'article-8', title: 'Article 8 - Sécurité des Données' },
  { id: 'article-9', title: 'Article 9 - Cookies' },
  { id: 'article-10', title: 'Article 10 - Transferts Internationaux' },
  { id: 'article-11', title: 'Article 11 - Mineurs' },
  { id: 'article-12', title: 'Article 12 - Modifications' },
  { id: 'article-13', title: 'Article 13 - Contact' },
];

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      title="Politique de Confidentialité"
      subtitle="LEMO - Protection de vos données personnelles"
      lastUpdate="26 décembre 2025"
      sections={sections}
    >
      <section id="article-1">
        <h2>Article 1 - Responsable du Traitement</h2>
        <p>
          Le responsable du traitement des données personnelles collectées via l'application 
          et le site web LEMO est :
        </p>
        <ul>
          <li><strong>Raison sociale</strong> : LEMO (Petites Natures)</li>
          <li><strong>Adresse</strong> : [Adresse à compléter]</li>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
        </ul>
      </section>

      <section id="article-2">
        <h2>Article 2 - Données Collectées</h2>
        
        <h3>2.1 - Données fournies par l'utilisateur</h3>
        <ul>
          <li><strong>Données d'identification</strong> : nom, prénom, adresse email, numéro de téléphone</li>
          <li><strong>Données de connexion</strong> : mot de passe (hashé et sécurisé)</li>
          <li><strong>Données de commande</strong> : historique des commandes, préférences alimentaires</li>
          <li><strong>Données de paiement</strong> : gérées directement par Stripe (LEMO ne stocke pas les données bancaires)</li>
        </ul>

        <h3>2.2 - Données collectées automatiquement</h3>
        <ul>
          <li><strong>Données de géolocalisation</strong> : position GPS (uniquement avec votre consentement)</li>
          <li><strong>Données techniques</strong> : adresse IP, type de navigateur, système d'exploitation, identifiant d'appareil</li>
          <li><strong>Données d'utilisation</strong> : pages consultées, actions effectuées, temps passé sur l'application</li>
        </ul>

        <h3>2.3 - Données des restaurants partenaires</h3>
        <ul>
          <li>Raison sociale, SIRET, adresse du restaurant</li>
          <li>Coordonnées du gérant (nom, email, téléphone)</li>
          <li>Données bancaires pour les virements (IBAN)</li>
          <li>Menus, photos, horaires d'ouverture</li>
        </ul>
      </section>

      <section id="article-3">
        <h2>Article 3 - Finalités du Traitement</h2>
        <p>Vos données sont collectées et traitées pour les finalités suivantes :</p>
        
        <h3>3.1 - Gestion des comptes utilisateurs</h3>
        <ul>
          <li>Création et gestion de votre compte LEMO</li>
          <li>Authentification et sécurité d'accès</li>
          <li>Personnalisation de l'expérience utilisateur</li>
        </ul>

        <h3>3.2 - Traitement des commandes</h3>
        <ul>
          <li>Prise en charge et suivi de vos commandes</li>
          <li>Communication avec les restaurants partenaires</li>
          <li>Facturation et gestion des paiements</li>
        </ul>

        <h3>3.3 - Communication</h3>
        <ul>
          <li>Envoi de confirmations de commande et mises à jour de statut</li>
          <li>Notifications push (avec votre consentement)</li>
          <li>Newsletters et offres promotionnelles (avec votre consentement)</li>
          <li>Réponses à vos demandes de support</li>
        </ul>

        <h3>3.4 - Amélioration des services</h3>
        <ul>
          <li>Analyse statistique de l'utilisation de la plateforme</li>
          <li>Détection et prévention des fraudes</li>
          <li>Amélioration de l'expérience utilisateur</li>
        </ul>
      </section>

      <section id="article-4">
        <h2>Article 4 - Base Légale du Traitement</h2>
        <p>Le traitement de vos données repose sur les bases légales suivantes :</p>
        <ul>
          <li><strong>Exécution du contrat</strong> : traitement des commandes, gestion du compte</li>
          <li><strong>Consentement</strong> : géolocalisation, notifications push, communications marketing</li>
          <li><strong>Intérêt légitime</strong> : amélioration des services, prévention des fraudes, statistiques</li>
          <li><strong>Obligation légale</strong> : conservation des factures, réponses aux réquisitions judiciaires</li>
        </ul>
      </section>

      <section id="article-5">
        <h2>Article 5 - Destinataires des Données</h2>
        <p>Vos données peuvent être partagées avec :</p>
        
        <h3>5.1 - Partenaires internes</h3>
        <ul>
          <li>Équipe LEMO (support client, technique, marketing)</li>
          <li>Restaurants partenaires (uniquement les données nécessaires au traitement de la commande)</li>
        </ul>

        <h3>5.2 - Prestataires techniques</h3>
        <ul>
          <li><strong>Stripe</strong> : traitement des paiements</li>
          <li><strong>Google Maps</strong> : services de géolocalisation</li>
          <li><strong>Resend</strong> : envoi d'emails transactionnels</li>
          <li><strong>Emergent.sh</strong> : hébergement de l'application</li>
        </ul>

        <h3>5.3 - Autorités</h3>
        <ul>
          <li>Autorités judiciaires en cas de réquisition légale</li>
          <li>Autorités fiscales pour les obligations déclaratives</li>
        </ul>
      </section>

      <section id="article-6">
        <h2>Article 6 - Durée de Conservation</h2>
        <p>Vos données sont conservées pendant les durées suivantes :</p>
        <ul>
          <li><strong>Données de compte</strong> : pendant la durée de l'inscription, puis 3 ans après la dernière activité</li>
          <li><strong>Données de commande</strong> : 5 ans (obligation comptable)</li>
          <li><strong>Données de facturation</strong> : 10 ans (obligation légale)</li>
          <li><strong>Données de connexion</strong> : 1 an</li>
          <li><strong>Cookies</strong> : 13 mois maximum</li>
        </ul>
        <p>
          À l'expiration de ces délais, vos données sont supprimées ou anonymisées.
        </p>
      </section>

      <section id="article-7">
        <h2>Article 7 - Vos Droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        
        <h3>7.1 - Droit d'accès</h3>
        <p>Vous pouvez demander une copie de toutes les données personnelles que nous détenons sur vous.</p>

        <h3>7.2 - Droit de rectification</h3>
        <p>Vous pouvez demander la correction de données inexactes ou incomplètes.</p>

        <h3>7.3 - Droit à l'effacement ("droit à l'oubli")</h3>
        <p>
          Vous pouvez demander la suppression de vos données personnelles, sauf si nous avons 
          une obligation légale de les conserver.
        </p>

        <h3>7.4 - Droit à la limitation du traitement</h3>
        <p>Vous pouvez demander la suspension du traitement de vos données dans certains cas.</p>

        <h3>7.5 - Droit à la portabilité</h3>
        <p>
          Vous pouvez demander à recevoir vos données dans un format structuré et lisible 
          par machine pour les transférer à un autre service.
        </p>

        <h3>7.6 - Droit d'opposition</h3>
        <p>Vous pouvez vous opposer au traitement de vos données à des fins de marketing direct.</p>

        <h3>7.7 - Droit de retrait du consentement</h3>
        <p>Vous pouvez retirer votre consentement à tout moment pour les traitements basés sur celui-ci.</p>

        <h3>7.8 - Comment exercer vos droits</h3>
        <p>Pour exercer vos droits, contactez-nous à :</p>
        <ul>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Application</strong> : Menu "Mon compte" → "Confidentialité"</li>
        </ul>
        <p>Nous répondrons à votre demande dans un délai de <strong>30 jours</strong>.</p>

        <h3>7.9 - Réclamation auprès de la CNIL</h3>
        <p>
          Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation 
          auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) :
        </p>
        <ul>
          <li><strong>Site web</strong> : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></li>
          <li><strong>Adresse</strong> : 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07</li>
        </ul>
      </section>

      <section id="article-8">
        <h2>Article 8 - Sécurité des Données</h2>
        <p>
          LEMO met en œuvre des mesures techniques et organisationnelles appropriées pour 
          protéger vos données personnelles :
        </p>
        <ul>
          <li><strong>Chiffrement</strong> : connexions HTTPS/TLS, mots de passe hashés (bcrypt)</li>
          <li><strong>Contrôle d'accès</strong> : accès restreint aux données selon les rôles</li>
          <li><strong>Surveillance</strong> : monitoring des systèmes et détection d'intrusion</li>
          <li><strong>Sauvegarde</strong> : sauvegardes régulières et sécurisées</li>
          <li><strong>Formation</strong> : sensibilisation de l'équipe à la protection des données</li>
        </ul>
      </section>

      <section id="article-9">
        <h2>Article 9 - Cookies et Traceurs</h2>
        
        <h3>9.1 - Cookies essentiels</h3>
        <p>Ces cookies sont nécessaires au fonctionnement de la plateforme :</p>
        <ul>
          <li>Cookies de session (authentification)</li>
          <li>Cookies de préférences (langue, panier)</li>
        </ul>

        <h3>9.2 - Cookies analytiques</h3>
        <p>
          Avec votre consentement, nous utilisons des cookies pour analyser l'utilisation 
          de la plateforme et améliorer nos services.
        </p>

        <h3>9.3 - Gestion des cookies</h3>
        <p>
          Vous pouvez gérer vos préférences de cookies à tout moment via les paramètres de 
          votre navigateur ou les paramètres de l'application.
        </p>
      </section>

      <section id="article-10">
        <h2>Article 10 - Transferts Internationaux</h2>
        <p>
          Certains de nos prestataires peuvent être situés en dehors de l'Union Européenne. 
          Dans ce cas, nous nous assurons que des garanties appropriées sont mises en place :
        </p>
        <ul>
          <li>Clauses contractuelles types de la Commission Européenne</li>
          <li>Prestataires certifiés (ex : Stripe, Google)</li>
        </ul>
      </section>

      <section id="article-11">
        <h2>Article 11 - Mineurs</h2>
        <p>
          L'utilisation de LEMO est réservée aux personnes âgées de <strong>16 ans et plus</strong>. 
          Nous ne collectons pas sciemment de données personnelles de mineurs de moins de 16 ans.
        </p>
        <p>
          Si vous êtes parent ou tuteur et pensez que votre enfant nous a fourni des données, 
          contactez-nous pour demander leur suppression.
        </p>
      </section>

      <section id="article-12">
        <h2>Article 12 - Modifications de la Politique</h2>
        <p>
          Nous nous réservons le droit de modifier cette Politique de Confidentialité à tout moment. 
          Les modifications seront notifiées par :
        </p>
        <ul>
          <li>Une notification dans l'application</li>
          <li>Un email adressé à votre compte</li>
          <li>Une mise à jour de la date de "Dernière mise à jour"</li>
        </ul>
        <p>
          Nous vous encourageons à consulter régulièrement cette page pour rester informé 
          de nos pratiques en matière de confidentialité.
        </p>
      </section>

      <section id="article-13">
        <h2>Article 13 - Contact</h2>
        <p>Pour toute question relative à cette Politique de Confidentialité ou à vos données personnelles :</p>
        <ul>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
          <li><strong>Adresse</strong> : [Adresse à compléter]</li>
        </ul>
      </section>
    </LegalPageLayout>
  );
}
